<img
  *ngIf="avatarLink"
  [ngClass]="{ 'avatar-big': size === 'big', avatar: size === 'small' }"
  matListAvatar
  [src]="avatarLink"
  onerror="this.src='./assets/img/avatars/default.png';"
/>
